var _path, _path2, _polygon, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    viewBox: "0 0 30 30",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.758,21.401c0,0,4.496,4.496,4.819,4.819c1.04,1.04,2.725,1.04,3.764,0c1.04-1.04,1.04-2.725,0-3.765  c-0.323-0.323-4.819-4.819-4.819-4.819L16.758,21.401z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.998,11.003l-3.201-0.8l-0.8-3.201l3.706-3.706c-2.129-0.677-4.551-0.176-6.24,1.512c-2.41,2.41-1.639,5.547,0.772,7.957  c2.41,2.41,5.547,3.182,7.957,0.771c1.689-1.689,2.19-4.111,1.512-6.239L23.998,11.003z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "12.5,11.5 9,8 8,5 4,3 2,5 4,9 7,10 10.5,13.5 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.879,8.879c-3.364,3.364-12.636,12.636-13,13c-1.172,1.172-1.172,3.071,0,4.243c1.172,1.172,3.071,1.172,4.243,0  c0.364-0.364,9.636-9.636,13-13L17.879,8.879z M7,25c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C8,24.552,7.552,25,7,25z  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceIcon);
export default __webpack_public_path__ + "static/media/maintenance_icon.0336441ba92a1d4e2b041f7ddb40f3f5.svg";
export { ForwardRef as ReactComponent };